import { useState, useEffect, useCallback } from 'react';
import './Hero.css';
import logoMecapisco from '../assets/images/logo-mecapisco.png';
import truckHero from '../assets/images/truck-hero.jpeg';
import truck1 from '../assets/images/truck1.jpeg';
import truck2 from '../assets/images/truck2.jpeg';
import truck3 from '../assets/images/truck3.jpeg';
import truck4 from '../assets/images/truck4.jpeg';
import truck5 from '../assets/images/truck5.jpeg';
import truck6 from '../assets/images/truck6.jpeg';
import truck7 from '../assets/images/truck7.jpeg';

const slides = [truckHero, truck1, truck2, truck3, truck4, truck5, truck6, truck7];

const INTERVAL = 4500;

export default function Hero() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % slides.length);
  }, []);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, INTERVAL);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <section id="inicio" className="hero">
      {/* Slides de fondo */}
      <div className="hero__slider">
        {slides.map((img, i) => (
          <div
            key={i}
            className={`hero__slide ${i === current ? 'hero__slide--active' : ''}`}
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
        <div className="hero__gradient" />
      </div>

      {/* Contenido */}
      <div className="container hero__content">
        <img src={logoMecapisco} alt="Mecapisco S.A.C." className="hero__logo" />
        <div className="hero__divider" />
        <h1 className="hero__title">
          Transporte de<br />Carga Pesada
        </h1>
        <p className="hero__subtitle">
          Soluciones logísticas seguras, eficientes y puntuales<br />
          desde Pisco para todo el Perú.
        </p>
        <div className="hero__actions">
          <a href="#contacto" className="hero__btn hero__btn--primary">
            Cotiza tu servicio
          </a>
          <a href="#servicios" className="hero__btn hero__btn--outline">
            Nuestros servicios
          </a>
        </div>
      </div>

      {/* Controles */}
      <button className="hero__arrow hero__arrow--prev" onClick={prev} aria-label="Anterior">
        &#8249;
      </button>
      <button className="hero__arrow hero__arrow--next" onClick={next} aria-label="Siguiente">
        &#8250;
      </button>

      {/* Dots */}
      <div className="hero__dots">
        {slides.map((_, i) => (
          <button
            key={i}
            className={`hero__dot ${i === current ? 'hero__dot--active' : ''}`}
            onClick={() => setCurrent(i)}
            aria-label={`Ir a imagen ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
